import { ComponentRef, Directive, ViewContainerRef, effect, inject, input, output } from '@angular/core';
import { AnySection } from '../types/section';
import { ComponentFactoryService, getLogger } from '@knorr-bremse-portals/ngx-components';
import { EditorIdService } from '../providers/editor-id.service';
import { environment } from '../../environments/environment.local';
import { SectionComponent } from '../components/section/section.component';
import { Loggers } from '../../express.tokens';


@Directive({
  selector: '[appDynamicSection]',
  standalone: true,
})
export class DynamicSectionDirective {

  public section = input.required<AnySection>();
  public readonly afterRender = output();

  private viewContainerRef = inject(ViewContainerRef);
  private componentFactoryService = inject(ComponentFactoryService);
  private editorIdService = inject(EditorIdService);
  private logger = getLogger(Loggers.Renderer);

  public constructor() {
    effect(async () => {
      const section = this.section();
      const name = section.component;

      const componentMirror = await this.componentFactoryService.getComponentMirrorByName(name)
      if (componentMirror === null) {
        this.logger.warning(`No component with name "${name}" registered in ComponentFactoryService`);
        return;
      }

      this.viewContainerRef.clear();
      const component = this.viewContainerRef.createComponent(componentMirror.type) as ComponentRef<SectionComponent<AnySection>>;
      component.setInput('attributes', section.attributes);
      component.setInput('anchor', section.anchor);
      component.instance.smallBreakpointMoveBottom = section.smallBreakpointMoveToBottom;
      component.instance.smallBreakpointReverseOrder = section.smallBreakpointReverseOrder;

      if (environment.firstSpirit === true) {
        if (section.editorId) {
          this.editorIdService.addEditorId(component.location.nativeElement, section.editorId);
        }
        if (section.createSectionButton) {
          component.setInput('createSectionButton', section.createSectionButton);
        }
        component.setInput('editorIds', section.editorIds);
      }

      this.afterRender.emit();
    });
  }

}
